import React from 'react';
import PortfolioContainer from "./components/PortfolioContainer";

import Footer from "./components/Footer";

const App = () => {

return (
<>
<PortfolioContainer />
<Footer />

</>
)
}

export default App;

